import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Component, Fragment } from 'react';
import { propArrayShape, propFunc, propShape, } from '../../../../helpers/custom-prop-types';
class TagFilterModalContent extends Component {
    constructor(props) {
        super(props);
        const { params } = this.props;
        const checked = {};
        Object.keys(params).forEach((key) => {
            if (key.indexOf('tag_') !== 0) {
                return;
            }
            if (!params[key]) {
                return;
            }
            checked[key.split('_')[1]] = true;
        });
        this.state = { checked };
    }
    render() {
        const { hideModal, setParam, solutionTag, solutionTagClass } = this.props;
        const { checked } = this.state;
        return (_jsxs("div", Object.assign({ className: 'modal-content' }, { children: [_jsx("div", Object.assign({ className: 'modal-header' }, { children: _jsx("h3", { children: "\u7D5E\u308A\u8FBC\u307F\u691C\u7D22" }) })), _jsx("div", Object.assign({ className: 'align-left vertical-scroll h280' }, { children: _jsx("dl", Object.assign({ className: 'modal-tag-select' }, { children: solutionTagClass.map((tagClass) => {
                            const tags = solutionTag.filter((tag) => tag.solutionTagClassId === tagClass.id);
                            if (tags.length === 0) {
                                return _jsx(Fragment, {}, tagClass.id);
                            }
                            return (_jsxs(Fragment, { children: [_jsx("dt", { children: tagClass.name }), _jsx("dd", { children: _jsx("ul", { children: tags.map((tag) => (_jsxs("li", { children: [_jsx("input", { checked: !!checked[tag.id], className: 'mdc-checkbox__native-control', id: `modal_tag_${tag.id}`, onChange: () => {
                                                            this.setState({
                                                                checked: Object.assign(Object.assign({}, checked), { [tag.id]: !checked[tag.id] }),
                                                            });
                                                        }, type: 'checkbox' }), _jsx("label", Object.assign({ htmlFor: `modal_tag_${tag.id}` }, { children: tag.name }))] }, tag.id))) }) })] }, tagClass.id));
                        }) })) })), _jsx("div", Object.assign({ className: 'align-center modal-footer' }, { children: _jsx("ul", { children: _jsx("li", { children: _jsx("button", Object.assign({ className: 'btn wide', onClick: () => {
                                    const payload = {};
                                    Object.keys(checked).forEach((key) => {
                                        payload[`tag_${key}`] = !!checked[key];
                                    });
                                    setParam(payload);
                                    hideModal();
                                }, type: 'button' }, { children: "\u4E0A\u8A18\u6761\u4EF6\u3067\u691C\u7D22" })) }) }) }))] })));
    }
}
TagFilterModalContent.propTypes = {
    hideModal: propFunc(),
    params: propShape().isRequired,
    setParam: propFunc().isRequired,
    solutionTag: propArrayShape().isRequired,
    solutionTagClass: propArrayShape().isRequired,
};
TagFilterModalContent.defaultProps = {
    hideModal: () => null,
};
export default TagFilterModalContent;
